import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Markdown from "markdown-to-jsx";
import { GuestService } from "../../services";
import { Image } from "grommet";
import moment from "moment-timezone";
import { useFetchHotel } from "./redux/hooks";
import { useTranslation } from "react-i18next";

export default function RegistrationCard() {
  const { t } = useTranslation();
  var { guestId } = useParams();
  const [booking, setBooking] = useState();
  const [content, setContent] = useState("");
  const { hotel } = useFetchHotel();

  GuestService.getBooking(guestId).then((response) => {
    const theBooking = response.data;
    if (theBooking._id) {
      setBooking(theBooking);
    }
  });

  useEffect(() => {
    if (!hotel || !booking) return;
    let md = hotel.registrationText + "\n\n";
    md += `**${t("registrationCard.bookingNumber")}:** ` + booking.bookingId + "\n\n";
    md +=
      `**${t("registrationCard.guestName")}:** ` +
      booking.guest.firstname +
      " " +
      booking.guest.lastname +
      "\n\n";
    md += `**${t("guestDetails.roomNumber")}:** ` + (booking.roomNumber || "-") + "\n\n";
    md +=
      `**${t("guestModal.checkin")}:** ` +
      moment.tz(booking.checkinDate, hotel.timezone).format("LLLL") +
      "\n\n";
    md +=
      `**${t("guestModal.checkout")}:** ` +
      moment.tz(booking.checkoutDate, hotel.timezone).format("LLLL") +
      "\n\n";
    md += `**${t("registrationCard.signature")}:**\n\n`;
    setContent(md);
  }, [hotel, booking, t]);

  return booking && booking.onlineCheckin ? (
    <div>
      <Markdown>{content}</Markdown>
      <Image src={booking.onlineCheckin.signature} height="100" />
    </div>
  ) : (
    <div>{t("common.error")}</div>
  );
}

RegistrationCard.propTypes = {};
RegistrationCard.defaultProps = {};
